import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import { ProviderDetails } from '@openx/components-provider/lib/components/ProviderDetails/ProviderDetails.tsx';
import type { ProvidersRouteParams } from '@openx/components-provider/lib/components/types.ts';
import { useCallback, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { listSearchParams } from '../../utils/useListCriteria.ts';

export const ProviderDetailsPage = () => {
  const { session } = useAuth();
  const { providerId = '' } = useParams<ProvidersRouteParams>();
  const navigate = useNavigate();
  const isAllowed = useMemo(() => isAdmin(session), [session]);

  const handleGoBack = useCallback(() => {
    navigate(`/providers?${listSearchParams.providers ?? ''}`);
  }, [navigate]);

  if (!isAllowed) return <AccessForbiddenPage />;

  return <ProviderDetails handleGoBack={handleGoBack} providerId={providerId} titlePrefix="OpenXSelect" />;
};
